import { createAction } from 'redux-actions';

const actions = {
  /**
   * [쿠폰] 기획전 데이터 변경하기
   */
  SET_DATA: 'coupon/SET_DATA',
  setData: createAction('coupon/SET_DATA'),

  /**
   * [쿠폰 리스트] 쿠폰 리스트 요청하기
   */
  GET_COUPON_LIST_REQUEST: 'coupon/GET_COUPON_LIST_REQUEST',
  GET_COUPON_LIST_SUCCESS: 'coupon/GET_COUPON_LIST_SUCCESS',
  getCouponList: createAction('coupon/GET_COUPON_LIST_REQUEST'),

  /**
   * [쿠폰 리스트] 쿠폰 리스트 엑셀 다운로드 요청하기
   */
  GET_COUPON_LIST_EXCEL_DOWNLOAD_REQUEST: 'coupon/GET_COUPON_LIST_EXCEL_DOWNLOAD_REQUEST',
  GET_COUPON_LIST_EXCEL_DOWNLOAD_SUCCESS: 'coupon/GET_COUPON_LIST_EXCEL_DOWNLOAD_SUCCESS',
  getCouponListExcelDownload: createAction('coupon/GET_COUPON_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [쿠폰 생성] 쿠폰 생성하기
   */
  INSERT_COUPON_REQUEST: 'coupon/INSERT_COUPON_REQUEST',
  insertCoupon: createAction('coupon/INSERT_COUPON_REQUEST'),

  /**
   *  [쿠폰 생성] 쿠폰 별 쿠폰 적용 가능 상품 아이템 리스트 요청하기
   */
  GET_COUPON_PRODUCT_ITEM_REQUEST: 'coupon/GET_COUPON_PRODUCT_ITEM_REQUEST',
  GET_COUPON_PRODUCT_ITEM_SUCCESS: 'coupon/GET_COUPON_PRODUCT_ITEM_SUCCESS',
  getCouponProductItemList: createAction('coupon/GET_COUPON_PRODUCT_ITEM_REQUEST'),

  /**
   *  [쿠폰 생성] 쿠폰 별 쿠폰 적용 가능 브랜드 아이템 리스트 요청하기
   */
  GET_COUPON_BRAND_ITEM_REQUEST: 'coupon/GET_COUPON_BRAND_ITEM_REQUEST',
  GET_COUPON_BRAND_ITEM_SUCCESS: 'coupon/GET_COUPON_BRAND_ITEM_SUCCESS',
  getCouponBrandItemList: createAction('coupon/GET_COUPON_BRAND_ITEM_REQUEST'),

  /**
   * 쿠폰에 연결된 상품 또는 브랜드의 아이템들을 초기화
   */
  RESET_COUPON_RELATED_ITEM_LIST: 'coupon/RESET_COUPON_RELATED_ITEM_LIST',
  resetCouponRelatedItemList: createAction('coupon/RESET_COUPON_RELATED_ITEM_LIST'),

  /**
   *  [쿠폰 생성] 전체 상품 리스트 EXCEL 다운로드
   */
  GET_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST: 'coupon/GET_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getCouponProductItemListExcelDownload: createAction('coupon/GET_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [쿠폰 생성] 전체 브랜드 리스트 EXCEL 다운로드
   */
  GET_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST: 'coupon/GET_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getCouponBrandItemListExcelDownload: createAction('coupon/GET_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [쿠폰 생성] 선택된 상품 리스트 EXCEL 다운로드
   */
  GET_SELECTED_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'coupon/GET_SELECTED_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getSelectedCouponProductItemListExcelDownload: createAction(
    'coupon/GET_SELECTED_COUPON_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  [쿠폰 생성] 선택된 브랜드 리스트 EXCEL 다운로드
   */
  GET_SELECTED_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'coupon/GET_SELECTED_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getSelectedCouponBrandItemListExcelDownload: createAction(
    'coupon/GET_SELECTED_COUPON_BRAND_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  [쿠폰 생성] 상품 리스트 EXCEL 업로드 유효성 체크
   */
  CHECK_VALID_COUPON_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST:
    'coupon/CHECK_VALID_COUPON_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  checkValidCouponProductItemListExcelUpload: createAction(
    'coupon/CHECK_VALID_COUPON_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  ),

  /**
   *  [쿠폰 생성] 상품 리스트 EXCEL 업로드
   */
  SET_COUPON_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_SUCCESS: 'coupon/SET_COUPON_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_SUCCESS',
  setCouponProductItemListExcelUpload: createAction('coupon/SET_COUPON_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_SUCCESS'),

  /**
   *  [쿠폰 생성] 브랜드 리스트 EXCEL 업로드 유효성 체크
   */
  CHECK_VALID_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_REQUEST:
    'coupon/CHECK_VALID_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  checkValidCouponBrandItemListExcelUpload: createAction(
    'coupon/CHECK_VALID_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  ),

  /**
   *  [쿠폰 생성] 브랜드 리스트 EXCEL 업로드
   */
  SET_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_SUCCESS: 'coupon/SET_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_SUCCESS',
  setCouponBrandItemListExcelUpload: createAction('coupon/SET_COUPON_BRAND_ITEM_LIST_EXCEL_UPLOAD_SUCCESS'),

  /**
   *  [쿠폰 생성] 해당 브랜드에서 쿠폰 적용 가능 상품 리스트 가져오기
   */
  GET_COUPON_APPLY_AVAILABLE_PRODUCT_LIST_REQUEST: 'coupon/GET_COUPON_APPLY_AVAILABLE_PRODUCT_LIST_REQUEST',
  GET_COUPON_APPLY_AVAILABLE_PRODUCT_LIST_SUCCESS: 'coupon/GET_COUPON_APPLY_AVAILABLE_PRODUCT_LIST_SUCCESS',
  getCouponApplyAvailableProductList: createAction('coupon/GET_COUPON_APPLY_AVAILABLE_PRODUCT_LIST_REQUEST'),

  /**
   * [쿠폰 편집] 쿠폰 정보 가져오기
   */
  GET_COUPON_INFO_REQUEST: 'coupon/GET_COUPON_INFO_REQUEST',
  GET_COUPON_INFO_SUCCESS: 'coupon/GET_COUPON_INFO_SUCCESS',
  getCouponInfo: createAction('coupon/GET_COUPON_INFO_REQUEST'),

  /**
   * [쿠폰 복사] 쿠폰 정보 가져오기
   */
  GET_COUPON_COPY_INFO_REQUEST: 'coupon/GET_COUPON_COPY_INFO_REQUEST',
  GET_COUPON_COPY_INFO_SUCCESS: 'coupon/GET_COUPON_COPY_INFO_SUCCESS',
  getCouponCopyInfo: createAction('coupon/GET_COUPON_COPY_INFO_REQUEST'),

  /**
   * [쿠폰 편집] 쿠폰 편집 요청하기
   */
  EDIT_COUPON_REQUEST: 'coupon/EDIT_COUPON_REQUEST',
  editCoupon: createAction('coupon/EDIT_COUPON_REQUEST'),

  /**
   * [쿠폰 상세] 쿠폰 상세 가져오기 (통계, 상세, 사용내역)
   */
  GET_COUPON_DETAIL_REQUEST: 'coupon/GET_COUPON_DETAIL_REQUEST',
  GET_COUPON_DETAIL_SUCCESS: 'coupon/GET_COUPON_DETAIL_SUCCESS',
  getCouponDetail: createAction('coupon/GET_COUPON_DETAIL_REQUEST'),

  /**
   * [쿠폰 상세] 쿠폰별 쿠폰 적용 가능 상품 정보 가져오기
   */
  GET_COUPON_PRODUCT_LINK_LIST_REQUEST: 'coupon/GET_COUPON_PRODUCT_LINK_LIST_REQUEST',
  GET_COUPON_PRODUCT_LINK_LIST_SUCCESS: 'coupon/GET_COUPON_PRODUCT_LINK_LIST_SUCCESS',
  getCouponProductLinkList: createAction('coupon/GET_COUPON_PRODUCT_LINK_LIST_REQUEST'),

  /**
   * [쿠폰 상세] 쿠폰별 쿠폰 적용 가능 브랜드 정보 가져오기
   */
  GET_COUPON_BRAND_LINK_LIST_REQUEST: 'coupon/GET_COUPON_BRAND_LINK_LIST_REQUEST',
  GET_COUPON_BRAND_LINK_LIST_SUCCESS: 'coupon/GET_COUPON_BRAND_LINK_LIST_SUCCESS',
  getCouponBrandLinkList: createAction('coupon/GET_COUPON_BRAND_LINK_LIST_REQUEST'),

  /**
   * [쿠폰 상세] 쿠폰 사용내역 리스트 요청하기
   */
  GET_COUPON_USAGE_HISTORY_LIST_REQUEST: 'coupon/GET_COUPON_USAGE_HISTORY_LIST_REQUEST',
  GET_COUPON_USAGE_HISTORY_LIST_SUCCESS: 'coupon/GET_COUPON_USAGE_HISTORY_LIST_SUCCESS',
  getCouponUsageHistoryList: createAction('coupon/GET_COUPON_USAGE_HISTORY_LIST_REQUEST'),

  /**
   * [쿠폰 상세] 쿠폰 사용내역 리스트 엑셀 다운로드 요청하기
   */
  GET_COUPON_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST: 'coupon/GET_COUPON_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST',
  getCouponUsageHistoryListExcelDownload: createAction('coupon/GET_COUPON_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [쿠폰 상세] 쿠폰 미사용내역 리스트 요청하기
   */
  GET_COUPON_UN_USAGE_HISTORY_LIST_REQUEST: 'coupon/GET_COUPON_UN_USAGE_HISTORY_LIST_REQUEST',
  GET_COUPON_UN_USAGE_HISTORY_LIST_SUCCESS: 'coupon/GET_COUPON_UN_USAGE_HISTORY_LIST_SUCCESS',
  getCouponUnUsageHistoryList: createAction('coupon/GET_COUPON_UN_USAGE_HISTORY_LIST_REQUEST'),

  /**
   * [쿠폰 상세] 쿠폰 미사용내역 리스트 엑셀 다운로드 요청하기
   */
  GET_COUPON_UN_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST:
    'coupon/GET_COUPON_UN_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST',
  getCouponUnUsageHistoryListExcelDownload: createAction(
    'coupon/GET_COUPON_UN_USAGE_HISTORY_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   * [쿠폰 발급] 발급할 쿠폰 리스트 가져오기
   */
  GET_ISSUED_COUPON_LIST_REQUEST: 'coupon/GET_ISSUED_COUPON_LIST_REQUEST',
  GET_ISSUED_COUPON_LIST_SUCCESS: 'coupon/GET_ISSUED_COUPON_LIST_SUCCESS',
  getIssuedCouponList: createAction('coupon/GET_ISSUED_COUPON_LIST_REQUEST'),

  /**
   * [쿠폰 발급] 쿠폰 발급받을 유저 리스트 요청하기
   */
  GET_GENERATE_COUPON_USER_LIST_REQUEST: 'coupon/GET_GENERATE_COUPON_USER_LIST_REQUEST',
  GET_GENERATE_COUPON_USER_LIST_SUCCESS: 'coupon/GET_GENERATE_COUPON_USER_LIST_SUCCESS',
  getGenerateCouponUserList: createAction('coupon/GET_GENERATE_COUPON_USER_LIST_REQUEST'),

  /**
   * [쿠폰 발급] 쿠폰 발급받을 유저 리스트 엑셀 다운로드 요청하기
   */
  GET_GENERATE_COUPON_USER_LIST_EXCEL_DOWNLOAD_REQUEST: 'coupon/GET_GENERATE_COUPON_USER_LIST_EXCEL_DOWNLOAD_REQUEST',
  GET_GENERATE_COUPON_USER_LIST_EXCEL_DOWNLOAD_SUCCESS: 'coupon/GET_GENERATE_COUPON_USER_LIST_EXCEL_DOWNLOAD_SUCCESS',
  getGenerateCouponUserListExcelDownload: createAction('coupon/GET_GENERATE_COUPON_USER_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [쿠폰 발급] 쿠폰 발급 준비 데이터 가져오기
   */
  GET_PREPARATION_GENERATE_COUPON_REQUEST: 'coupon/GET_PREPARATION_GENERATE_COUPON_REQUEST',
  GET_PREPARATION_GENERATE_COUPON_SUCCESS: 'coupon/GET_PREPARATION_GENERATE_COUPON_SUCCESS',
  getPreparationGenerateCoupon: createAction('coupon/GET_PREPARATION_GENERATE_COUPON_REQUEST'),

  /**
   * [쿠폰 발급] 검색으로 선택한 쿠폰 리스트 가져오기
   */
  GET_SEARCH_COUPON_RESULT_REQUEST: 'coupon/GET_SEARCH_COUPON_RESULT_REQUEST',
  GET_SEARCH_COUPON_RESULT_SUCCESS: 'coupon/GET_SEARCH_COUPON_RESULT_SUCCESS',
  getSearchCouponResult: createAction('coupon/GET_SEARCH_COUPON_RESULT_REQUEST'),

  /**
   * [쿠폰 발급] 쿠폰 발급 요청하기
   */
  GENERATE_COUPON_SUCCESS: 'coupon/GENERATE_COUPON_SUCCESS',

  /**
   * [쿠폰 발급] 엑셀 일괄 발급 유효성 체크요청하기
   */
  EXCEL_BULK_GENERATE_COUPON_CHECK_REQUEST: 'coupon/EXCEL_BULK_GENERATE_COUPON_CHECK_REQUEST',
  excelBulkGenerateCouponCheck: createAction('coupon/EXCEL_BULK_GENERATE_COUPON_CHECK_REQUEST'),

  /**
   * [쿠폰 발급 내역 리스트] 쿠폰 발급 내역 리스트 가져오기
   */
  GET_COUPON_ISSUE_HISTORY_LIST_REQUEST: 'coupon/GET_COUPON_ISSUE_HISTORY_LIST_REQUEST',
  GET_COUPON_ISSUE_HISTORY_LIST_SUCCESS: 'coupon/GET_COUPON_ISSUE_HISTORY_LIST_SUCCESS',
  getCouponIssueHistoryList: createAction('coupon/GET_COUPON_ISSUE_HISTORY_LIST_REQUEST'),

  /**
   * [쿠폰 발급 내역 상세] 쿠폰 발급 내역 상세 가져오기
   */
  GET_COUPON_ISSUE_HISTORY_DETAIL_REQUEST: 'coupon/GET_COUPON_ISSUE_HISTORY_DETAIL_REQUEST',
  GET_COUPON_ISSUE_HISTORY_DETAIL_SUCCESS: 'coupon/GET_COUPON_ISSUE_HISTORY_DETAIL_SUCCESS',
  getCouponIssueHistoryDetail: createAction('coupon/GET_COUPON_ISSUE_HISTORY_DETAIL_REQUEST'),

  /**
   *  [쿠폰 발급 내역 상세] 쿠폰 발급 리스트 가져오기
   */
  GET_COUPON_ISSUE_HISTORY_COUPON_GENERATED_LIST_REQUEST:
    'coupon/GET_COUPON_ISSUE_HISTORY_COUPON_GENERATED_LIST_REQUEST',
  GET_COUPON_ISSUE_HISTORY_COUPON_GENERATED_LIST_SUCCESS:
    'coupon/GET_COUPON_ISSUE_HISTORY_COUPON_GENERATED_LIST_SUCCESS',
  getCouponIssueHistoryCouponGeneratedList: createAction(
    'coupon/GET_COUPON_ISSUE_HISTORY_COUPON_GENERATED_LIST_REQUEST',
  ),

  /**
   * 모달 토글
   */
  TOGGLE_MODAL: 'coupon/TOGGLE_MODAL',
  toggleModal: createAction('coupon/TOGGLE_MODAL'),
};

export default actions;
